import { RumGlobal } from '@datadog/browser-rum';
import { Intercom } from '@supy-io/ngx-intercom';
import {
  AmplitudeReturn,
  BaseEvent,
  BrowserClient,
  BrowserOptions,
  EventOptions,
  Identify,
  IdentifyUserProperties,
  Result,
  Revenue,
  TransportType,
  ValidPropertyType,
} from '@amplitude/analytics-types';
import { Context } from 'node:vm';

export class NoopIntercom implements Partial<Intercom> {
  boot(): void {
    /* No Action */
  }

  shutdown(): void {
    /* No Action */
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  trackEvent(_eventName: string): void {
    /* No Action */
  }

  update(): void {
    /* No Action */
  }
}

type NoopDatadogRumType = Pick<
  RumGlobal,
  | 'init'
  | 'addAction'
  | 'addError'
  | 'setUser'
  | 'setGlobalContextProperty'
  | 'setGlobalContext'
  | 'addFeatureFlagEvaluation'
  | 'getGlobalContext'
>;

export const NoopDatadogRum: NoopDatadogRumType = {
  /* eslint-disable */
  init(_initConfiguration): void {},
  setUser(_newUser): void {},
  addError(error: unknown, context?: object | undefined): void {},
  setGlobalContextProperty(_key, _value): void {},
  setGlobalContext(_newContext): void {},
  addAction(name: string, context?: object | undefined): void {},
  addFeatureFlagEvaluation(_key: string, _value): void {},
  getGlobalContext(): Context {
    return {};
  },
};

export class NoopAmplitudeClient implements Partial<BrowserClient> {
  extendSession(): void {
    /*no implementation */
  }

  flush(): AmplitudeReturn<void> {
    return undefined;
  }

  getDeviceId(): string | undefined {
    return undefined;
  }

  getSessionId(): number | undefined {
    return undefined;
  }

  getUserId(): string | undefined {
    return undefined;
  }

  groupIdentify(
    groupType: string,
    groupName: string | string[],
    identify: Identify,
    eventOptions?: EventOptions,
  ): AmplitudeReturn<Result> {
    return undefined;
  }

  identify(identify: Identify, eventOptions?: EventOptions): AmplitudeReturn<Result> {
    return undefined;
  }

  init(apiKey: string, options?: BrowserOptions): AmplitudeReturn<void>;
  init(apiKey: string, userId?: string, options?: BrowserOptions): AmplitudeReturn<void>;
  init(apiKey: string, options?: BrowserOptions | string): AmplitudeReturn<void> {
    return undefined;
  }

  logEvent(
    eventInput: BaseEvent | string,
    eventProperties?: Record<string, any>,
    eventOptions?: EventOptions,
  ): AmplitudeReturn<Result> {
    return undefined;
  }

  remove(pluginName: string): AmplitudeReturn<void> {
    return undefined;
  }

  reset(): void {
    /*no implementation */
  }

  revenue(revenue: Revenue, eventOptions?: EventOptions): AmplitudeReturn<Result> {
    return undefined;
  }

  setDeviceId(deviceId: string): void {
    /*no implementation */
  }

  setGroup(groupType: string, groupName: string | string[], eventOptions?: EventOptions): AmplitudeReturn<Result> {
    return undefined;
  }

  setOptOut(optOut: boolean): void {
    /*no implementation */
  }

  setSessionId(sessionId: number): void {
    /*no implementation */
  }

  setTransport(transport: TransportType): void {
    /*no implementation */
  }

  setUserId(userId: string | undefined): void {
    /*no implementation */
  }

  track(
    eventInput: BaseEvent | string,
    eventProperties?: Record<string, any>,
    eventOptions?: EventOptions,
  ): AmplitudeReturn<Result> {
    return undefined;
  }
}

export class NoopIdentify implements Identify {
  add(property: string, value: number): Identify {
    return undefined;
  }

  append(property: string, value: ValidPropertyType): Identify {
    return undefined;
  }

  clearAll(): Identify {
    return undefined;
  }

  getUserProperties(): IdentifyUserProperties {
    return undefined;
  }

  postInsert(property: string, value: ValidPropertyType): Identify {
    return undefined;
  }

  preInsert(property: string, value: ValidPropertyType): Identify {
    return undefined;
  }

  prepend(property: string, value: ValidPropertyType): Identify {
    return undefined;
  }

  remove(property: string, value: ValidPropertyType): Identify {
    return undefined;
  }

  set(property: string, value: ValidPropertyType): Identify {
    return undefined;
  }

  setOnce(property: string, value: ValidPropertyType): Identify {
    return undefined;
  }

  unset(property: string): Identify {
    return undefined;
  }
}
